<div class="canned-inspection-add">
  <div class="canned-inspection-header flex-between-center p-2 b-bottom-gray-85">
    <div class="width-100p">
      <app-input
        type="text"
        [theme]="cannedInspection?.title && !errors.title ? 'light' : 'secondary'"
        [hasBgOnActive]="true"
        [isInvalid]="errors.title"
        [value]="cannedInspection?.title"
        placeholder="Enter inspection checklist name"
        (appChange)="handleChange($event)"
        (appFocus)="handleFocus('title')"
        [autoFocus]="true"
      >
      </app-input>
    </div>
    <i (click)="close()" class="close-icon fal fa-times pointer"></i>
  </div>

  <p-tabView class="tab-panel-underline tab-panel-estimates tab-panel-default" (onChange)="selectedTab = $event">
    <p-tabPanel [selected]="selectedTab === 0">
      <ng-template pTemplate="header"> Basic info </ng-template>
      <ng-template pTemplate="content">
        <div class="select-category-section pt-2 pb-2" #cannedInspectionAddBody cdkScrollable>
          <div cdkDropList class="example-list" [cdkDropListData]="cannedInspection?.categories" (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="dragDisabled">
            <div class="example-box" *ngFor="let category of cannedInspection?.categories; let i = index" cdkDragBoundary=".select-category-section" cdkDrag>
              <app-accordian
                [data]="category"
                headerLabel="title"
                headerCountLabel="items"
                listItemKey="inspectionItems"
                [isDragable]="true"
                listItemLabel="title"
                [hasCustomSelectedItemText]="false"
                [hasItemCheckbox]="true"
                checkBoxPosition="end"
                [hasCustomTemplate]="false"
                [hasHeaderCheckbox]="true"
                [iconSize]="10"
                [fontSize]="12"
                [showSelectedItem]="true"
                [index]="i"
                [hasDeleteOption]="true"
                [listItemIdKey]="'itemId'"
                (handleHeaderCheckChange)="handleAllSelectChange($event, i)"
                (handleItemSelectChange)="handleSelectChange($event, i)"
                (handleDelete)="handleDeleteAccordian($event)"
                (dragDisabled)="handleDragDisabled()"
              >
              </app-accordian>
            </div>
          </div>

          <div class="ui-g">
            <div class="ui-g-8">
              <app-dropdown placeholder="Select category" theme="border" [options]="categories" [isDropdownIconVisible]="true" [showSelectedValue]="false" (appSelect)="onSelect($event)">
              </app-dropdown>
            </div>
          </div>
        </div>

        <div class="canned-inspection-footer flex-end-center p-2 b-top-gray-85">
          <button (click)="close()" class="btn btn-border pointer width-80 mr-2">Cancel</button>
          <button class="btn btn-primary btn-100" [disabled]="isProcessing" (click)="handleSubmit()">
            <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
            <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
          </button>
        </div>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel [selected]="selectedTab === 1">
      <ng-template pTemplate="header"> Activity logs </ng-template>
      <ng-template pTemplate="content">
        <div class="activity-logs">
          <div class="catalog-activity-wrapper">
            <!-- Activity logs -->
            <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
              <div *ngFor="let activityLog of activityLogs">
                <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
              </div>
            </div>

            <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
              <p>There are no activity logs.</p>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>
